import { Children, type ReactNode } from 'react';
import { Box, styled } from '@lingoda/ui';

const MULTI_COLUMN_THRESHOLD = 4;
const SINGLE_COLUMN_MAX_WIDTH = 600;

interface OptionListProps {
    children: ReactNode;
    columns?: 'single' | 'auto';
}

export const OptionList = (props: OptionListProps) => {
    const isTwoColumns =
        props.columns !== 'single' && Children.count(props.children) > MULTI_COLUMN_THRESHOLD;

    return <StyledGrid twoColumns={isTwoColumns}>{props.children}</StyledGrid>;
};

const StyledGrid = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'twoColumns',
})<{ twoColumns: boolean }>(({ theme, twoColumns }) => ({
    display: 'grid',
    gap: theme.spacing(2),
    width: '100%',
    marginInline: 'auto',
    maxWidth: twoColumns ? undefined : SINGLE_COLUMN_MAX_WIDTH,
    gridTemplateColumns: twoColumns ? '1fr 1fr' : '1fr',
    [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
    },
}));
